<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column is-12">
          <h1 class="title">About Us</h1>
        </div>
      </div>

      <div class="columns">
        <div class="column is-12">
          <p>
            <a href="//car-trackr.com">car-trackr.com</a> is hobby project of
            <a href="https://github.com/kandrejevs">Krišs Andrejevs</a>.
          </p>

          <p>
            If you have found a bug and want to get in touch, please email me to
            <a href="mailto:info@car-trackr.com">info@car-trackr.com</a>.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AboutUs',
};
</script>

<style scoped>

</style>
